<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="View Homework">
      <v-card-text class="pt-0 pr-1"
        :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">

        <!--Filter Section Start -->
        <v-row>
          <!-- <v-col cols="12" md="2">

            <label class="label">From </label>
            <div class="control">
              <input class="input" type="date" v-model="filter.fromDate"
                v-on:change="onFilterChange()" required />
            </div>

          </v-col>
          <v-col cols="12" md="2">

            <label class="label">To </label>
            <div class="control">
              <input class="input" v-on:change="onFilterChange()" type="date"
                v-model="filter.toDate" :minToDate="filter.fromDate" required />
            </div>

          </v-col> -->

          <v-col cols="12" md="6" lg="2">
            <label class="font-weight-medium body-2">
              Class
            </label>
            <v-autocomplete class="my-0 py-1" placeholder="--All Classes--" name="classSelect"
              v-model="selectedClassID" required v-on:change="changeSections()" item-value="id"
              :items="classes" key="id" item-text="name">
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="6" lg="2">
            <label class="font-weight-medium body-2">
              Section
            </label>
            <v-autocomplete class="my-0 py-1" placeholder="--All Sections--" name="sectionSelect"
              v-model="selectedSectionID" required v-on:change="getStudentHomework()"
              item-value="id" :items="classWiseSections" key="id" item-text="name">
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="6" lg="2">
            <label class="font-weight-medium body-2">
              Status
            </label>
            <v-autocomplete class="my-0 py-1" placeholder="--All--" name="statusSelect"
              v-model="filter.status" required v-on:change="getStudentHomework()" item-value="id"
              :items="statusOptions" key="opt" item-text="name">
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="6" lg="2" class="pt-2 mt-3">
            <label class="font-weight-medium body-2">From </label>
            <custom-date-picker label="From" dense prepend-icon="mdi-calendar"
              :maxToDate="maxToDate" v-model="filter.fromDate" required />
          </v-col>
          <v-col cols="12" md="6" lg="2" class="pt-2 mt-3">
            <label class="font-weight-medium body-2">To </label>
            <custom-date-picker label="To" dense prepend-icon="mdi-calendar"
              :minToDate="filter.fromDate" v-model="filter.toDate" required />
          </v-col>
          <v-col cols="12" md="6" lg="2">
            <span class="font-weight-medium body-2">Action</span>
            <div class="inside">
              <v-btn elevation="1" color="success" @click="getStudentHomework('template')">
                <v-icon left>mdi-magnify</v-icon>Search
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <!--Filter section end -->
      </v-card-text>
      <v-divider class=" my-0 " />
      <v-data-table :footer-props="{
          'items-per-page-options': [5, 10, 20, 40]
        }" :items-per-page="10" item-key="uniqueKey" :headers="headers" :items="homeworks">
        <template v-slot:item.approvalStatus="{item}">
          <div id="status" :class="getColor(item.approvalStatus)">
            {{ item.approvalStatus }}
          </div>
        </template>
        <template v-slot:item.date="{item}">
          <div>
            {{  formatDate(item.date) }}
          </div>
        </template>
        <!--Table Actions Start -->
        <template v-slot:item.actions="{item}">
          <v-container v-if="item.approvalStatus!=='Not Submitted'">
            <v-container v-if="item.studentHomeWorks.length>0">
              <router-link
                :to="{ name: `reviewHomework`, params: { subjectId: item.id, studentId: item.studentID }  }">
                <v-btn color="success" class="px-2 ml-1 ma-1" min-width="0" small>
                  <v-icon small> mdi-pencil </v-icon> <span class="ml-1">Review</span>
                </v-btn>
              </router-link>
            </v-container>
          </v-container>
        </template>
        <!--Table Actions End -->

        <!--No Data template start -->
        <template v-slot:no-data>
          <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
        </template>
        <!--No Data template end -->
      </v-data-table>
    </material-card>
    <!-- Loader Start -->
    <loading-icon :value="isLoading" />
    <!-- Loader End -->
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import MaterialCard from '@/components/template/MaterialCard'
import CustomDatePicker from '@/components/template/CustomDatePicker'
import constants from '@/utils/constants'
import moment from 'moment'
export default {
  name: 'viewHomework',
  components: { MaterialCard, CustomDatePicker },
  created () {
    this.getClassList()
  },
  mounted () {
    if (window.sessionStorage.getItem('viewHomeworkOption')) {
      let previousSelection = JSON.parse(window.sessionStorage.getItem('viewHomeworkOption'))
      this.previousSelection = previousSelection
      this.selectedClassID = previousSelection.classID
      this.selectedSectionID = previousSelection.sectionID
      this.filter.fromDate = previousSelection.fromdate
      this.filter.toDate = previousSelection.todate
    } else {
      this.filter.fromDate = moment().subtract(1, 'month').format('YYYY-MM-DD')
      this.filter.toDate = moment().format('YYYY-MM-DD')
    }
    this.getStudentHomework()
  },
  data: function () {
    return {
      maxToDate: moment().format('YYYY-MM-DD'),
      isLoading: false,
      previousSelection: null,
      searchFilterArray: [],
      classWiseSections: [],
      homeworks: [],
      status: '',
      statusOptions: [
        {
          name: 'All',
          opt: ''
        },
        {
          name: 'Reviewed',
          opt: 'Reviewed'
        },
        {
          name: 'Not Reviewed',
          opt: 'Not Reviewed'
        },
        {
          name: 'Not Submitted',
          opt: 'Not Submitted'
        }
      ],
      headers: [
        { text: 'Student Name', sortable: true, value: 'studentName' },
        { text: 'Class', sortable: false, value: 'studentClass.name' },
        { text: 'Section', sortable: true, value: 'studentSection.name' },
        { text: 'Date', sortable: true, value: 'date' },
        { text: 'Status', sortable: true, value: 'approvalStatus' },
        { text: 'Action', sortable: false, value: 'actions', align: 'center' }
      ],
      classes: [],
      sections: [],
      selectedSectionID: '',
      timer: null,
      selectedClassID: '',
      filter: {
        fromDate: '',
        toDate: '',
        status: '',
        franchiseeID: '',
        academicYearID: '',
        stage: 'All'
      }
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    franchisee: async function (val) {
      if (val) {
        this.filter.franchiseeID = val.id
        this.getStudentHomework()
      }
    },
    academicYear: function (val) {
      if (val) {
        this.filter.academicYearID = val.id
        this.getStudentHomework()
      }
    },
    selectedClassID (val) {
      console.log(val)
    }
  },
  methods: {
    getStudentHomework: async function (callFrom = '') {
      try {
        this.isLoading = true
        let requestParams = {}
        // if (this.filter.status === 'Reviewed' || this.filter.status === 'Not Reviewed') {
        //   requestParams.approvalStatus = this.filter.status
        // }

        if (this.academicYear && this.selectedClassID && this.selectedSectionID && this.franchisee) {
          requestParams.isActive = true
          requestParams.franchiseeID = this.franchisee.id
          requestParams.academicYearID = this.academicYear.id
          requestParams.classID = this.selectedClassID
          requestParams.sectionID = this.selectedSectionID
          requestParams.fromdate = this.filter.fromDate
          requestParams.todate = this.filter.toDate
          if (this.franchisee.id !== '') {
            const { data } = await http.get(`${constants.API_URL}/api/communication/listStudentHomeworks`, {
              params: requestParams
            })
            window.sessionStorage.setItem('viewHomeworkOption', JSON.stringify(requestParams))
            this.homeworks = this.processData(data, this.filter.status)
            console.log('__Homeworks___', this.homeworks)
          } else {
            if (callFrom !== '') {
              this.$buefy.toast.open({
                message: 'Please select franchisee ID.',
                type: 'is-warning',
                duration: 4000
              })
            }
          }
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.$buefy.toast.open({
          message: errorMessage,
          type: 'is-danger',
          duration: 4000
        })
      }
    },
    formatDate (date) {
      return moment(date).format('LL')
    },
    getHomeworkId (studentHomeWorks, studentID) {
      studentHomeWorks.forEach((item) => {
        if (item.studentID === studentID) {
          console.log('___Result___', item.id)
          return item.id
        }
      })
    },
    processData: function (data, approvalStatus) {
      let submitted = []
      let notSubmitted = []
      let homeworkIDs = []
      // let result = []
      console.log(data)
      data.forEach((item) => {
        if (homeworkIDs.indexOf(item.id) === -1) {
          homeworkIDs.push(item.id)
          item.allStudents.forEach((student) => {
            let flag = false
            item.studentHomeWorks.forEach((homework) => {
              if (homework.studentID === student.id) {
                flag = true
                console.log('_____Result push')
                submitted.push(
                  Object.assign(
                    {
                      uniqueKey: Math.floor(100000 + Math.random() * 900000)
                    },
                    {
                      approvalStatus: homework.approvalStatus,
                      studentID: student.id,
                      studentName: student.studentEnrollment.studentName
                    },
                    item
                  )
                )
              }
            })

            if (!flag) {
              notSubmitted.push(
                Object.assign(
                  {
                    uniqueKey: Math.floor(100000 + Math.random() * 900000)
                  },
                  {
                    approvalStatus: 'Not Submitted',
                    studentID: student.id,
                    studentName: student.studentEnrollment.studentName
                  },
                  item
                )
              )
            }
          })
        }
      })
      switch (approvalStatus) {
        case 'Reviewed':
          return submitted.filter((ele) => {
            return ele.approvalStatus === 'Reviewed'
          })
        case 'Not Reviewed':
          return submitted.filter((ele) => {
            return ele.approvalStatus === 'Not Reviewed'
          })
        case 'Not Submitted':
          return notSubmitted
        default:
          return submitted.concat(notSubmitted)
      }
    },
    getClassList: async function () {
      try {
        this.isLoading = true
        let response = await http.get(`${constants.API_URL}/api/student/class-section`)
        const data = response.data
        this.classes = data
        // Selecting the first class ID
        if (this.previousSelection !== null) {
          if (this.previousSelection.classID) {
            this.selectedClassID = this.previousSelection.classID
          }
        } else {
          this.selectedClassID = this.classes[0].id
        }

        this.sections = data.map((obj) => {
          return {
            id: obj.id,
            sections: obj.studentSections
          }
        })
      } catch (e) {
        console.log(e)
      } finally {
        this.changeSections()
        this.isLoading = false
      }
    },
    getColor (status) {
      if (status === 'Reviewed') return 'v-green font-weight-bold'
      else if (status === 'Not Reviewed') return 'v-error font-weight-bold'
      else if (status === 'Not Submitted') return 'v-warning font-weight-bold'
      else return 'v-secondary '
    },
    changeSections: async function () {
      try {
        this.isLoading = true
        let sectionarray = this.sections.find((obj) => obj.id === this.selectedClassID)
        if (sectionarray) {
          this.classWiseSections = sectionarray.sections
          // Selecting first section of the retrieved records
          this.selectedSectionID = this.classWiseSections[0].id
        } else {
          this.classWiseSections = []
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.isLoading = false
        this.getStudentHomework()
      }
    }
  }
}
</script>
<style scoped>
</style>
